import { FieldType as FormFieldType } from '@/components/Form';
import {
  adaptFormDataFunction,
  adaptFormFieldFunction,
  parseFormDataFunction,
} from '@/modules/corporate/modules/database/fields/types';

import { getPicklistValues } from '../select/utils';

export const adaptFormData: adaptFormDataFunction = (data) => {
  return data?.value ? data.value.split(',') : [];
};

export const adaptFormField: adaptFormFieldFunction = ({ field, t }) => ({
  type: FormFieldType.MultiPicklist,
  size: 'large',
  placeholder: t('Common:Actions.Select'),
  picklistValues: getPicklistValues(field),
});

export const parseFormData: parseFormDataFunction = (data: string[]) => ({
  value: data.join(','),
});
